module.exports = __webpack_public_path__ + "media/images/illustrations/most_popular-3971d64e0d90176e77a7a5d001966fcc.svg";